<div class="mt-5 ">
    <!--centered-->
    <div class="row" style="margin:0;">
        <div class="col col-md-4 col-sm-12">
            <div *ngIf="parks.length == 0" style="display: inline-flex;" class="mb-1">

                <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning"
                    [style.width]="'100%'">
                    Lista vuota. Non hai parchi mezzi assegnati,
                    contatta un amministratore di sistema per amministrare dei parchi mezzi.
                </li>
            </div>
        </div>
    </div>

    <div class="row" style="margin:0;">
        <div class="col col-md-4 col-sm-12">
            <accordion [closeOthers]="true">
                <accordion-group *ngFor="let park of parks" class="mt-2" [(isOpen)]="park.isOpen"
                                 (isOpenChange)="openChanged(park)">
                    <div class="clearfix" accordion-heading>
                        <div class="pull-left float-left pt-2">{{ park.name }}</div>
                        <!-- <span class="badge badge-secondary float-right pull-right">Some HTML here</span> -->
                        <button class="btn btn-link float-right pull-right" [disabled]="!vehicles[park.id]" >
                            <i class="fas fa-file-excel iconCustom"
                               (click)="exportService.exportAuto(vehicles[park.id])"></i>
                        </button>
                    </div>
                    <li class="list-group-item d-flex justify-content-between align-items-center"
                        *ngFor="let vehicle of vehicles[park.id]" [class.list-group-item-alert]='vehicle.is_away'>
                        <div style="width: 100%;">
                            <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                                <div class="col-12">
                                    <b>{{vehicle.plate}}</b> (#{{vehicle.id}})
                                    <span class="badge badge-pill badge-alert" style="display:inline; margin-right: 1px; "
                                                 [class.cursor-click]="true"
                                                 (click)="fermiTecnici(vehicle)">
                                        Fermi tecnici
                                    </span>
                                    <span class="badge badge-pill badge-info" style="display:inline; margin-right: 1px; "
                                        [class.cursor-click]="true"
                                        (click)="getVehicleDocument(vehicle)">
                                        RCA
                                    </span>

                                </div>
                                <div class="col-12">
                                    Chilometraggio <b> {{ vehicle.utlimi_chilometri }} </b>  km
                                </div>
                                <div class="col-12">
                                    Ultimo Viaggio <b> {{ vehicle.ultimo_viaggio  | date: 'dd/MM/yyyy'  }} </b>
                                </div>

                                <div class="col-9">
                                    {{ vehicle.model.brand.name }} {{ vehicle.model.name }}
                                </div>

                                <div class="col-3" style="display: inline-grid; margin: auto;">
                                    <span class="badge badge-primary badge-pill" style="display:inline; margin:1px;"
                                          [class.cursor-click]="vehicle.refused > 0" (click)="showRefused(vehicle)">
                                        <i class="fa fa-times"
                                           style="margin-right:2px;"></i>{{ vehicle.refused > 1000 ? '999+' : vehicle.refused }}
                                    </span>

                                    <span class="badge badge-classic badge-pill" style="display:inline; margin:1px;"
                                          [class.cursor-click]="vehicle.pending > 0" (click)="showPending(vehicle)">
                                        <i class="far fa-clock"
                                           style="margin-right:2px;"></i>{{ vehicle.pending > 1000 ? '999+' : vehicle.pending }}
                                    </span>

                                    <span class="badge badge-success badge-pill" style="display:inline; margin:1px;"
                                          [class.cursor-click]="vehicle.approved> 0" (click)="showApproved(vehicle)">
                                        <i class="fa fa-check"
                                           style="margin-right:2px;"></i>{{ vehicle.approved > 1000 ? '999+' : vehicle.approved}}
                                    </span>
                                </div>

                            </div>

                            <div style="width: 100%;  display: flex; flex-wrap: wrap;" *ngIf="vehicle.is_away">
                                <div class="col-9">
                                    {{dateHandlerService.formatDateClassic(vehicle.is_away_until)}} :
                                    {{dateHandlerService.formatTimeClassic(vehicle.is_away_until)}}
                                </div>
                            </div>

                            <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                                <!--<ngx-charts-heat-map
                                        [legend]="false"
                                        [results]="data_prova"
                                        [xAxis]="true"
                                        [yAxis]="true"
                                        [gradient]="true"
                                        [scheme]="colorScheme"
                                        [tooltipText]="tooltipText"
                                        [customColors]="customColors">
                                </ngx-charts-heat-map> -->

                            </div>
                            <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                                <div class="col-3" style="display: grid;">
                                    <span class="badge badge-alert badge-pill" style="display:inline; margin-top: 5px; "
                                          [class.cursor-click]="true" (click)="showTravel(vehicle)">
                                        <i class="fa fa-car" style="margin-right:2px;"></i>
                                        {{ vehicle.travels > 1000 ? '999+' : vehicle.travels }}
                                    </span>

                                </div>
                                <div class="col-3" style="display: grid;">
                                    <span class="badge badge-pill"
                                          [class.badge-success]=
                                                  "vehicle.last_fuel_level && vehicle.last_fuel_level > 3 "
                                          [class.badge-alert]=
                                                  "vehicle.last_fuel_level && vehicle.last_fuel_level == 3 "
                                          [class.badge-danger]=
                                                  "vehicle.last_fuel_level && vehicle.last_fuel_level < 3 "
                                          style="display:inline; margin-top: 5px; ">
                                        <i class="fas fa-gas-pump"></i>
                                        {{vehicle.last_fuel_level == 1 ? '&#48;' :   ''}}
                                        {{vehicle.last_fuel_level == 2 ? '&#188;' :  ''}}
                                        {{vehicle.last_fuel_level == 3 ? '&#189;' :  ''}}
                                        {{vehicle.last_fuel_level == 4 ? '&#190;' :  ''}}
                                        {{vehicle.last_fuel_level == 5 ? '&#49;' :   ''}}
                                    </span>

                                </div>
                                <div class="col-6" style="display: grid;">
                                    <span class="badge badge-pill" style="display:inline; margin-top: 5px; "
                                          [class.badge-success]=
                                                  "vehicle.chilometri_litro > 5 && vehicle.chilometri_litro < 20"
                                          [class.badge-danger]=
                                                  "vehicle.chilometri_litro < 5 || vehicle.chilometri_litro > 20">
                                        {{ vehicle.chilometri_litro.toFixed(2) }} km/lt
                                    </span>

                                </div>
                            </div>

                            <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                                <div class="col-12" style="display: grid;">
                                    <span class="badge badge-secondary badge-pill" style="display:inline; margin-top: 5px; "
                                          [class.cursor-click]="true" (click)="assignVehicle(vehicle)">
                                        <i class="fa fa-user"></i> Assegna
                                    </span>
                                </div>
                            </div>

                        </div>

                    </li>
                </accordion-group>
            </accordion>
        </div>

        <div class="col col-md-8 col-sm-12" style="padding:0;" [hidden]="!loadstats">

            <div class="mt-5" [hidden]="data_is_away.length === 0">
                <label><b>Auto con viaggi aperti</b></label>
                <div style="display: grid">
                    <ngx-charts-number-card [(results)]="data_is_away" [view]="view_is_away" [scheme]="'vivid'"
                                            [bandColor]="'rgba(0, 0, 0, 0)'">
                    </ngx-charts-number-card>
                </div>
            </div>
           <!-- ----------------------------FINE  COMPONENTE VEICOLI DISPONIBILI --------------->

            <div class="mt-5" [hidden]="data_consumi.length === 0">
                <label><b>Consumi per auto, rapporto Km/Lt</b></label>
                <div style="height: 500px;">
                    <ngx-charts-bar-vertical legendTitle="Consumi" [results]="data_consumi" [xAxis]="true" [yAxis]="true"
                                             [view]="view_consumi"
                                             [showYAxisLabel]="true" [yAxisLabel]="'Chilometri per litro'"
                                             [customColors]="customColors" [legend]="false">
                    </ngx-charts-bar-vertical>
                </div>
            </div>

            <div class="mt-5" [hidden]="data.length === 0">
                <label><b>Viaggi per auto</b></label>
                <div style="display: grid;">
                    <ngx-charts-bar-horizontal [scheme]="'vivid'" [results]="data" [view]="viewTravels"
                                               [yAxis]="true" (select)="showTravelFromChart($event)"
                                               [customColors]="customColorsTravels" >

                    </ngx-charts-bar-horizontal>
                    <!--<ngx-charts-pie-chart legendTitle="Auto" [gradient]="true" [scheme]="'vivid'" [labels]="true" [results]="data"
            [doughnut]="true" [legend]="true" (select)="showTravelFromChart($event)">
          </ngx-charts-pie-chart>-->
                </div>
            </div>

            <div class="mt-5" [hidden]="data_rifornimenti.length === 0">
                <label><b>Rifornimenti per auto</b></label>
                <div #barParent style="display: grid; ">
                    <ngx-charts-bar-horizontal-stacked legendTitle="Rifornimenti" [results]="data_rifornimenti"
                                                       [scheme]="scheme_rifornimenti" [yAxis]="true" [xAxis]="true"
                                                       [showXAxisLabel]="true"
                                                       [xAxisLabel]="'Rifornimenti'" [view]="view" [legend]="true"
                                                       (select)="showRefills($event)">
                        <ng-template #tooltipTemplate let-model="model">
                            {{model.series}}: {{model.value}} rifornimenti {{model.name}} <br>
                            Totale: euro {{model.total}}
                        </ng-template>
                    </ngx-charts-bar-horizontal-stacked>
                </div>
            </div>

            <div class="mt-5" [hidden]="data_is_not_used.length === 0">
                <label><b>Auto non utilizzate</b></label>
                <div style="display: grid">
                    <ngx-charts-number-card [(results)]="data_is_not_used" [view]="view_is_not_used" [scheme]="'vivid'">
                    </ngx-charts-number-card>
                </div>
            </div>

        </div>
    </div>

    <app-fermi-tecnici (createRequested)="createFermo($event)"></app-fermi-tecnici>
    <app-create-fermo-tecnico (fermoCreated)="fermiTecnici($event)"></app-create-fermo-tecnico>
    <app-assign-user-to-car (vehicleAssigned)="vehicleAssigned()"></app-assign-user-to-car>
</div>
